import { observer } from '../animations/animate';
import { GalleryPage } from '../helpers/enums';
import { showVideo } from '../video/videoThumbnail';

/* Dynamically create a <video> */
export const generateVideo = (video: HTMLElement, page: GalleryPage) => {
  const newElementContainer = document.createElement('div');
  newElementContainer.classList.add('w--100', 'h--100', 'flex', 'justify-content--center');

  /* Thumbnail button */
  const newElementBtn = document.createElement('button');
  newElementBtn.setAttribute('aria-label', 'Play video');
  newElementBtn.setAttribute('js-video-thumbnail', 'true');
  newElementBtn.classList.add('video-thumbnail', 'w--100', 'h--100');
  newElementBtn.addEventListener('click', () => {
    showVideo(newElementBtn);
  });

  /* Create new <picture> */
  const newElementPicture = document.createElement('picture');

  /* Create desktop srcset, if exists */
  if (video.hasAttribute('srcDesktopThumb')) {
    const newElementSrcDesktop = document.createElement('source');
    newElementSrcDesktop.setAttribute('media', '(min-width: 64em)');
    newElementSrcDesktop.setAttribute('srcset', video.getAttribute('srcDesktopThumb')!);
    newElementPicture.append(newElementSrcDesktop);
  }

  /* Create tablet srcset, if exists */
  if (video.hasAttribute('srcTabletThumb')) {
    const newElementSrcTablet = document.createElement('source');
    newElementSrcTablet.setAttribute('media', '(min-width: 48em)');
    newElementSrcTablet.setAttribute('srcset', video.getAttribute('srcTabletThumb')!);
    newElementPicture.append(newElementSrcTablet);
  }

  /* Create mobile srcset, if exists */
  if (video.hasAttribute('srcMobileThumb')) {
    const newElementSrcMobile = document.createElement('source');
    newElementSrcMobile.setAttribute('media', '(min-width: 0)');
    newElementSrcMobile.setAttribute('srcset', video.getAttribute('srcMobileThumb')!);
    newElementPicture.append(newElementSrcMobile);
  }

  /* Thumbnail img */
  const newElementImg = document.createElement('img');

  const urlAttribute = video.getAttribute('srcMobile') ?? '';
  const urlToUse = urlAttribute?.includes('1x') ? urlAttribute?.split('1x')[0].trim() : urlAttribute;

  newElementImg.setAttribute('src', urlToUse);
  newElementImg.setAttribute('alt', video.getAttribute('thumbAlt')!);
  newElementImg.classList.add('img-cover');
  if (page === GalleryPage.CAROUSEL) {
    newElementImg.classList.add('object-fit--contain');
  }
  newElementPicture.append(newElementImg);

  /* Video */
  const newElementVideo = document.createElement('video');
  newElementVideo.setAttribute('controls', 'true');
  newElementVideo.setAttribute('playsinline', 'true');
  newElementVideo.setAttribute('crossorigin', 'anonymous');
  newElementVideo.classList.add('img-cover', 'hidden');
  if (page === GalleryPage.CAROUSEL) {
    newElementVideo.classList.add('w--max', 'object-fit--contain');
  }

  /* Create new <source> */
  const newElementSrc = document.createElement('source');
  newElementSrc.setAttribute('type', 'video/mp4');
  newElementSrc.setAttribute('src', video.getAttribute('src')!);

  /* Append */
  newElementBtn.append(newElementPicture);
  newElementVideo.append(newElementSrc);
  newElementContainer.append(newElementBtn);
  newElementContainer.append(newElementVideo);

  /* Apply animation effect to new video */
  if (page === GalleryPage.GRID) {
    newElementContainer.setAttribute('js-animate', 'fade-in');
    observer.observe(newElementContainer);
  }

  return newElementContainer;
};
